import React from 'react';
const Controller = ({ currentUser, ...props }) => {
  return (
    <React.Fragment>
      {React.cloneElement(props.children, {
        ...props,
        currentUser,
      })}
    </React.Fragment>
  );
};

export default Controller;
